<template>
  <div :id="id" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" :class="[scrollable,size]" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title" v-html="title"></div>
          <button type="button" class="closebtn" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0">
          <component :is="comp" :data="data" :key="title"></component>
        </div>
        <div class="modal-footer p-1" v-if="footer">
          <component :is="footerComp" :data="data"></component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      id: {
        type: String,
        default: () => ''
      },
      title: {
        type: String,
        default: () => ''
      },
      comp: {
        type: [String, Object]
        // default: () => ""
      },
      size: {
        type: String,
        default: () => ''
      },
      data: {
        type: [String, Object]
        // default: () => ""
      },
      scroll: {
        type: Boolean,
        default: () => false
      },
      footer: {
        type: Boolean,
        default: () => false
      },
      footerComp: {
        type: [String, Object]
        // default: () => ""
      }
    },
    data () {
      return {}
  },
    computed: {
      scrollable () {
        return this.scroll ? 'modal-dialog-scrollable' : ''
      }
    },
    created () {
      // console.log(this.size);
    }
  }

</script>
<style>
  .bg-grey {
    background: #f1f3f4;
  }

  .modal-header {
    padding: .7rem 1rem !important;
    line-height: 1.25rem !important;
  }

  .modal-title {
    line-height: 1.5rem !important;
    color: rgba(0, 0, 0, 0.6);
  }

  /* .close {
        font-weight: 300 !important;
        opacity: .5 !important;
    } */

</style>



// WEBPACK FOOTER //
// src/components/Modal.component.vue